$(function(){
 

  
  $(".mylazyload").each(function(){
    //$(this).attr("src", $(this).attr("data-imgsrc"));
  });
});
$(document).ready(function(){
  
  setTimeout(function(){
  // $('#slidecarthq .footer').append('<a class="button full" href="https://www.finnandemma.com/tools/shappify-csp/v2/create_draft_order">Checkout</a>');
  // $('#slidecarthq .footer').addClass('active');
  }, 1600);
  
  $('body').on('click', '[name="checkout"]', function(e){
     
  //  window.location.href = "https://www.finnandemma.com/tools/shappify-csp/v2/create_draft_order";
  });
  
  
  // mambership
  $('.join_mambers').click(function(e){
    	$('.mamber_ship').show();
    	e.preventDefault();
  });
  $('.mamber_ship .close').click(function(){  
    $('.mamber_ship').hide();
  });
  
   //remove_title_proi();
  
  // bird house
  birdhouse_slider();
  $('.bh-quAns').click(function(){
    
   if(!$(this).hasClass('active'))
    {
    
  		 $(this).parent('.bh_faq_section').children('.bh-quAns').each(function(){
            if( $(this).hasClass('active')  )
               {
					$(this).find('.bh-answer').slideToggle();
                    $(this).removeClass('active');
               }
            });
    
    	$(this).addClass('active');
    	$(this).find('.bh-answer').slideToggle();
    }else{
        $(this).removeClass('active');
    	$(this).find('.bh-answer').slideToggle();
      }
    
    	 
  });
  
  $('.search').click(function(){
    $(this).addClass('search--focus');
    $(this).children('input').focus();
  });
  $('.search__input').focusout(function(){
    	$(this).closest('.search').removeClass('search--focus');
  });
  
  //thumb images
  thumb_img_box_size();;
  
  
  //filter
 $("body").on("click", ".custome_shorting ul li", function(){
  // $('select.filters-toolbar__input').val($(this).html()).attr("selected", "true");
   $('select.filters-toolbar__input').find( 'option[value="' + $(this).html() + '"]' ).prop( "selected", true ); 
  // $('select.filters-toolbar__input').find( 'option[value="' + $(this).html() + '"]' ).trigger("change");
 //  $("select.filters-toolbar__input option[value='"+$(this).html()+"']").attr('selected', 'selected');
   
 });
  
  $("body").on("click", ".bc-sf-filter-option-value", function(){
		var clo = $(this).parent().closest('.bc-sf-filter-option-block').attr('data-type');    
    
      if (clo == 'collection')
      {
      	var coll =  $(this).html();       
        $('.page_tittle h1').html(coll);
        $('.breadcrumb span:last-child').html(coll);
      }
    
    
});
  

  
  
  //faq
  $('.inner_box_faq .q_heading').click(function(){
    
    if(!$(this).hasClass('active'))
    {
    
  		 $(this).parent('.inner_box_faq').parent('.faq_section_box').children('.inner_box_faq').each(function(){
            if( $(this).children('.q_heading').hasClass('active')  )
               {
					$(this).children('.q_heading').next('.q_asked').slideToggle();
                    $(this).children('.q_heading').removeClass('active');
               }
            });
    
    	$(this).addClass('active');
    	$(this).next('.q_asked').slideToggle();
    }else{
        $(this).removeClass('active');
    	$(this).next('.q_asked').slideToggle();
      }
  });
  
  
  $(".size-chart-cov a").click(function(event){
    event.preventDefault();
    $("#size-chart-pop").fadeIn();
  });
  $(".close-chart").click(function(){
     $("#size-chart-pop").fadeOut();
  });
  
  
  
  //popup
  $('.popup_inner_box .close').click(function(){
    	$('.popup_box').hide();
    	setCookie("homepopup", "yes", 1);
  });
  checkCookie();
  
  
responsive_filter_sidebar();	
  
  // sidebar
  $('.sidebar-block .widget-title').click(function(){
    $(this).next('.widget-content').slideToggle();
    if( $(this).children().children('.plus').hasClass("active"))
    {
      $(this).children().children('.subt').addClass("active");
       $(this).children().children('.plus').removeClass("active");
    }
    else
    {
      $(this).children().children('.subt').removeClass("active");
       $(this).children().children('.plus').addClass("active");
    }
  });
  
  
  
 /* $('.sidebar-block .show-first').next('.widget-content').slideToggle();
   $('.sidebar-block .show-first').children().children('.subt').addClass("active");
   $('.sidebar-block .show-first').children().children('.plus').removeClass("active");*/
  
  
  // filter
   // $('.btn_apply').click(function(){
     $('.container input').change(function() {
    var sz='', cl='', cn='';
   
     $('.size ul li').each(function(){
      if( $(this).children('label').children('input[type="checkbox"]').is(":checked"))
      {
        sz=sz+$(this).children('label').children('input[type="checkbox"]').val()+'+';       
      }
      
    });
       if($(this).hasClass('collection_check')){
          	cl=$(this).val();
         	cn = $(this).attr('data-name');
          }
                                  
    /* $('.show_collection_fillter ul li').each(function(){
       if($(this).children('label').children('input[type="checkbox"]').prop("checked"))
       {
         cl=$(this).children('label').children('input[type="checkbox"]').val();
         cn = $(this).children('label').children('input[type="checkbox"]').attr('data-name');
       } 
      
    }); */
       
    if( cl !='')
    {
     	/*if(sz !='' )
        {
          var urlStr = cl+'/?constraint='+sz+cn;
          window.location.replace(urlStr);
        }
      	else
        {
          var urlStr = cl; //+'/?constraint='+cn; 
          window.location.replace(urlStr);
        }*/
           var urlStr = cl; //+'/?constraint='+cn;
          window.location.replace(urlStr);
      
    }else{
        if(sz !='' )
        {
          var urlStr = '?constraint='+sz;
         //var urlStr= '?q='+sz;
          window.location.replace(urlStr);
        }  
    }
       if( cl =='' & sz =='')
       {
         var urlStr = '?constraint=';
     	 window.location.replace(urlStr);
       }
    
  });
  
   
  
  
  $('.btn_clear').click(function(){
     var urlStr = '?constraint=';
      window.location.replace(urlStr);
   
  });
/*
  $(".myBx").each(function(){
    
    $(this).bxSlider({ 
			    nextText: '',
			    prevText: '',
			    touchEnabled: true,
			    pager: false,
			    auto: false,
			    autoControls: false,
			});
  
  });
  
   $('.testimonial-slider').bxSlider({ 

            nextText: '',
            prevText: '',
            minSlides: 1,
            maxSlides: 3,
            moveSlides:1,
            infiniteLoop: true,
            slideWidth: 400,
            responsive: true,
            touchEnabled: true,
            pager: false,
            auto: false,
            autoControls: false,
     		shrinkItems: true,
	});
  

   if($(window).width() > 769)
  {
   $('.three-box-slider').bxSlider({
			mode: 'horizontal',
			moveSlides: 1,
			slideMargin: 20,		
            slideWidth: 280,
			minSlides: 4,
			maxSlides: 4,
			auto: false,
			pager: false,
     		shrinkItems: true,
            easing: 'swing',
     		infiniteLoop: true,
            speed: 300,
    		swipeThreshold: 20,
		});
  }
  else
  {
      $('.three-box-slider').bxSlider({
			mode: 'horizontal',
			moveSlides: 1,
			slideMargin: 30,		
            slideWidth: 280,
			minSlides: 1,
			maxSlides: 2,
			auto: false,
			pager: false,
     		shrinkItems: true,
            easing: 'swing',
     		infiniteLoop: true,
            speed: 300,
    		swipeThreshold: 20,
		});
  }
*/
  
   
  $('.bc-sf-filter-block-content').hide();
  $('.bc-sf-filter-block-title span').addClass('up');
  $('#bc-sf-filter-options-wrapper .bc-sf-filter-option-block:first-child .bc-sf-filter-block-content').show();
  $('#bc-sf-filter-options-wrapper .bc-sf-filter-option-block:first-child .bc-sf-filter-block-content span').removeClass('up');  
  
  
  
  
  
  
  // swatch
  
  $('.swatch .toggler .swatch-element').click(function(){
    if( ! $(this).closest('.toggler').hasClass('soldout')){
    	var sw_value = $(this).attr('data-value');
         var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    	$('.swatch .toggler').removeClass('active');
    	$(this).parent('.toggler').addClass('active');
    	$(this).closest('form').find('select.single-option-selector').eq(optionIndex).val(sw_value).trigger('change');
    	$('.size_option_custome .current_size').html(sw_value);
    }
  });
 
  $('.size_option_custome .current_size').html($('.swatch .toggler.active .swatch-element').attr('data-value'));
  
  
});


//product instagram

$(window).on('load', function(){  

  setTimeout(function(){ 
 	 instagram_slider();  
    
    
  }, 3000);
  
  /*
  $('.bc-sf-filter-block-content').hide();
  $('.bc-sf-filter-block-title span').addClass('up');
  $('#bc-sf-filter-options-wrapper .bc-sf-filter-option-block:first-child .bc-sf-filter-block-content').show();
  $('#bc-sf-filter-options-wrapper .bc-sf-filter-option-block:first-child .bc-sf-filter-block-content span').removeClass('up');    
  */
  
  var right=0;
  $("body").on("click", ".paging .next", function(){
   	  var screen_width =  $('.inner-page-product').width();  
  	  var inst_feed_wth = $('#insta-feed').width();
    
    	  right=right+screen_width;
          if( inst_feed_wth > (right + screen_width))
          {        
             $('#insta-feed').css({'right':  right+"px"});
          }
          else
          {

            var cus_left= inst_feed_wth - right;
            right= right-screen_width;
            right=right+cus_left;
            $('#insta-feed').css({'right': right+'px'});
          }
          
    
    
    
    
   /* if(!$(this).hasClass('active'))
    {
      var note= $('.paging li').index(this);
     
      var activ_not=0;
    
      $('.paging li').each(function(){
        	
			if($(this).hasClass('active'))
            {
              activ_not = $('.paging li').index(this); 
            }
        
      });
      
     
      if(note > activ_not)
      {
         // next
          right=right+screen_width;
          if( inst_feed_wth > (right + screen_width))
          {        
             $('#insta-feed').css({'right':  right+"px"});
          }
          else
          {

            var cus_left= inst_feed_wth - right;
            right= right-screen_width;
            right=right+cus_left;
            $('#insta-feed').css({'right': right+'px'});
          }
           $('.paging li').removeClass('active');
           $(this).addClass('active');
      }else
      { 
          right=right-screen_width;
          if( right > 0)
          {        
             $('#insta-feed').css({'right':  right+"px"});
          }
          else
          {            
            right=right+screen_width;
            var cus_left= inst_feed_wth - (right+screen_width);
            right=0;
            $('#insta-feed').css({'right': cus_left+'px'});
          }
           $('.paging li').removeClass('active');
           $(this).addClass('active');
      	
      }
                                     
   }*/
    
    
    
    });
  
  $("body").on("click", ".paging .prv", function(){
    var screen_width =  $('.inner-page-product').width();  
  	  var inst_feed_wth = $('#insta-feed').width();
     if(right>0)
     {
    	right=right-screen_width;
       	
          if( right >= 0)
          {        
             $('#insta-feed').css({'right':  right+"px"});
            
          }
          else
          {            
           // right=right+screen_width;
           // var cus_left= inst_feed_wth - (right+screen_width);
            right=0;
            $('#insta-feed').css({'right': right+'px'});
          }
     }
  });
  
  
       $("body").on("click", "a.swatch-element-link", function(){
          setTimeout(function(){
            hide_insta_feed();
            
          }, 4000);
         
       });
      
      
 $(".prod-title").click(function(){
     $(this).next().slideToggle();
    $(this).toggleClass('active');
            
  });

     $("body").on("click", ".spr-header-title", function(){            
            $('.spr-reviews').slideToggle();
     });
   
});




function birdhouse_slider()
{
  if($(window).width() > 769)
  {
	var r_w = $('.review-txt .review-txt-box').width();   
    $('.review-txt .review-txt-box-inner').css('height', r_w+'px');
  }
  else
  {
    $('.review-txt .review-txt-box-inner').removeAttr('style');
    
  }
}

function instagram_slider()
{
  
   var i=0
  	$('.inner-page-product #insta-feed .container').each(function(){
  		i++;
   });
   var itme_width = $('.inner-page-product #insta-feed .container').width();                    
   var width_inst = (itme_width+10)*i;
  /* var screen_width =  $(window).width();
   var noofslider = width_inst / screen_width ;
   var noofsliders =noofslider.toPrecision(1);
  
     var dot ='<li class="dot"><span></span></li>';
     var dot_html='';
   if( noofslider > noofsliders )
   {
    
        for(var j=-1; j < noofsliders; j++ )
        {
          dot_html=dot_html + dot;           
        }
     	
     	$('.paging').html(dot_html);
   }
   else
   {
   		
   		 for(var j=0; j <  noofsliders; j++ )
        {
          dot_html=dot_html+dot;
        }
        $('.paging').html(dot_html);
   }
   
   $('.paging li:first-child').addClass('active');*/
   $('.inner-page-product #insta-feed').css('width', width_inst);
}

function hide_insta_feed()
{
  var show_insta = $('.instagram-box .l2h-photos-container').html();
  if( typeof show_insta === 'undefined')
  {
    $('.instagram-box').hide()
  }
}

$(window).on("load", function(){
  

  
  hide_insta_feed();

  
    if($(window).width() < 769)
  {
     $(".product-bx .grid--uniform").bxSlider({
        auto: false,
        minSlides: 1,
        maxSlides: 1,
        moveSlides:1,
           infiniteLoop: true,
        slideWidth: 1200,
    responsive: true,
			    pager: false,
			    auto: false,
			    autoControls: false,
     
    
     });
    
  }else{
  
  
  $(".product-bx .grid--uniform").bxSlider({
        auto: false,
        minSlides: 4,
        maxSlides: 4,
        moveSlides:1,
    infiniteLoop: true,
        slideWidth: 1200,
    responsive: true,
			    pager: false,
			    auto: false,
			    autoControls: false,
 });
  
  }
  
  
  
  // mobile filter
  $('.filter_icon_box img').click(function(){
    $('.sidebar-block').slideToggle();
  });
  
});

$(window).resize(function(){
	responsive_filter_sidebar();
  thumb_img_box_size();
  
  instagram_slider();
  birdhouse_slider();
});


function thumb_img_box_size()
{
  var window_w= $(window).width();
  if(window_w > 768)
  {
    var prod_img = $('img.feature-row__image').width()+45;
    $('.product-single__thumbnails').css('width', prod_img);
  }
  else
  {
    $('.product-single__thumbnails').css('width', '100%');
  }
  
}

function responsive_filter_sidebar(){
  	var win_size = $(window).width();
    	if(win_size < 769)
    	{
       		$(".sidebar-custom .widget-title span.subt").removeClass("active");
      		$(".sidebar-custom .widget-title span.plus").addClass("active");
    	}
  		else
  		{
       		$(".sidebar-custom .widget-title span.subt").addClass("active");
      		$(".sidebar-custom .widget-title span.plus").removeClass("active");
  		}
 	}



function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {
    var pop = getCookie("homepopup");
    if (pop != "") {
        //alert("Welcome again " + user);
    } else {
      $('.popup_box').show();
       //user = prompt("Please enter your name:","");
      
       //if (user != "" && user != null) {
           //setCookie("homepopup", user, 1);
       //}
    }
}


$(window).on('load', function(){
  
//title  
  
  remove_title_proi();
  
  $('body').on('click', '#bc-sf-filter-bottom-pagination li a', function(){
   	 
    setTimeout(function(){
     remove_title_proi();
    }, 500);
    
      
   	setTimeout(function(){
     remove_title_proi();
    }, 2000);
    
  });
  
  
   $('body').on('click', '.sca-qv-button', function(){
     
    hide_default_variant();
  });
  
  $('.ictxt_item').mouseenter(function(){
    var id = $(this).data('id');
    $('.ictxt_item, .ictxt_bottom').removeClass('active');
    $(this).addClass('active');
    $('.ictxt_bottom[data-id="'+id+'"]').addClass('active');
    
  });
  
  $('.plus_mins').on('click', function(){
    $(this).closest('.mobile-nav__item').toggleClass('active');
    $(this).closest('.mobile-nav__item').find('.mobie_submenu').slideToggle();
  });
  
  
  
  $('body').on('click', '#bc-sf-filter-tree-mobile-button', function(){
    $(this).removeClass('active');
    $('.detail_collecton').removeClass('active');
  });
  
});

$(function(){
   $("body").on("click", ".js-mobile-nav-toggle", function(){      
      $('body').toggleClass('hide_scroll');
    });
  
  $('body').on('click', '.Sort_by', function(){
    $('#bc-sf-filter-tree-mobile-button').trigger('click').addClass('active');
    $('.detail_collecton').addClass('active');
    
    $(this).hide();
    //$(this).show();
    show_dropwon($(this));
  });
  
  function show_dropwon(that){
    setTimeout(function(){
    	that.show();
    }, 60);
  }
  
  
  
   $('.home_slider_slick').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      arrows: true
    });
  
	
});

function hide_default_variant(){
  setTimeout(function(){
    
    var size = $('select#sca-qv-product-selected-option-0 option').length;
    if(size == 0){
      hide_default_variant();
    }else{
       
         console.log(size);
        if(size==1 && $('select#sca-qv-product-selected-option-0').val() == 'Default'){
          $('select#sca-qv-product-selected-option-0').closest('.selector-wrapper').hide();
        }
     
    }

  }, 1200);
}


function remove_title_proi()
{
   $('#bc-sf-filter-products .grid__item').each(function(){  
     var tit = $.trim($(this).children('.grid-view-item').children('.grid-view-item__link').find('.grid-view-item__title').html());
      tit = tit.replace(/(<([^>]+)>)/ig,"");
     if( tit.indexOf('|') != -1 ||  tit.indexOf('[') != -1){
      var arr = tit.split('|');
      var arr2 = arr[0].split('[');
      
      var arr_l = arr[(arr.length - 1)].split('[');     
      $(this).children('.grid-view-item').children('.grid-view-item__link').find('.grid-view-item__title').html(arr2[0]+'<br/>'+arr_l[(arr_l.length - 1)]);	
     }
     
  });
  $('#bc-sf-filter-right #bc-sf-filter-products').show();
}



 